import React from "react";
import classNames from "classnames";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import CheckBox from "../../../../../../components/form/Checkbox";
import CroField from "../../../generalForm/CroField";
import CroPriceField from "../../../generalForm/CroPriceField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import {
  fieldsRemove,
  notForPublic,
  isLogged,
  isNotLogged,
} from "../../../../CroUtils";
import { Source } from "../../../../enum";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { Field } from "redux-form";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

export default ({
  meta: { submitFailed },
  fields,
  disabled,
  noPublicLogged,
  onSourceCheck,
  t,
  defaultCountry,
  isPublicStatement,
  auth,
  ongoing,
  outgoing,
  dos,
  isCity,
  isVillage,
  onICOChange,
  aresErrors,
  versionChangedClass
}) => {
  const cityOrVillage = isNotLogged(auth) && !isCity && !isVillage;
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index, sources) => {
        const checkboxLabelStyle =
          submitFailed && !sources.get(index).sourceType
            ? { color: "red" }
            : {};
        return (
          <div
            key={index}
            className={classNames("cro-array-item", {
              noUnderline: !cityOrVillage,
            }, versionChangedClass ? versionChangedClass(item) : "")}
          >
            <ItemNumber index={index} />
            {!disabled && fields.length > 1 && (
                <CroRemoveButton onClick={() => removeItem(index)} />
            )}
            <div className="cro-array-item-content">
              <div className="statementForm__arrayGrid">
                {(cityOrVillage || isLogged(auth)) && (
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                    title="Druh závazku"
                    name={`${item}.type`}
                    component={Input}
                    disabled={disabled}
                    validate={[V.required]}
                    helpEnum={H[`${t}LIABILITY_TYPE`].r}
                    maxlen={1000}
                  />
                )}
                {(cityOrVillage || isLogged(auth)) && (
                  <CroPriceField
                    className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                    title="Výše závazku"
                    name={`${item}.price`}
                    component={Input}
                    disabled={disabled}
                    validate={[V.required, V.isNumeric]}
                    helpEnum={H[`${t}LIABILITY_PRICE`].r}
                  />
                )}

                {(cityOrVillage || isLogged(auth)) && (
                  <div className="statementForm__arrayFull">
                    <div className="checkbox-row">
                      <Field
                        className={versionChangedClass ? versionChangedClass(`${item}.sourceType`) : ""}
                        name={`${item}.sourceType`}
                        component={Input}
                        type="hidden"
                        style={{ display: "none" }}
                        validate={[V.required]}
                      />
                      <div className="checkbox">
                        <label className="title" style={checkboxLabelStyle}>
                          Věřitel - Fyzická osoba
                        </label>
                        <CheckBox
                          value={
                            sources.get(index).sourceType === Source.PERSON
                          }
                          onChange={onSourceCheck(
                            `${item}.sourceType`,
                            Source.PERSON,
                          )}
                          disabled={disabled}
                          aria-label="Věřitel - Fyzická osoba"
                        />
                      </div>
                      <div className="checkbox">
                        <label className="title" style={checkboxLabelStyle}>
                          Věřitel - Právnická osoba
                        </label>
                        <CheckBox
                          value={
                            sources.get(index).sourceType ===
                            Source.LEGAL_PERSON
                          }
                          onChange={onSourceCheck(
                            `${item}.sourceType`,
                            Source.LEGAL_PERSON,
                          )}
                          disabled={disabled}
                          aria-label="Věřitel - Právnická osoba"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {sources.get(index).sourceType === Source.PERSON &&
                  (cityOrVillage || isLogged(auth)) && (
                    <div className="statementForm__arrayFull">
                      <div className="statementForm__arrayGrid statementForm__arrayGrid--3col">
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.firstName`) : ""}
                          title="Jméno"
                          name={`${item}.firstName`}
                          component={Input}
                          disabled={disabled}
                          validate={[
                            V.required,
                            V.textSpaceDashOnly,
                            V.noSpaceStartEnd,
                          ]}
                        />
                        {notForPublic(isPublicStatement, auth) && (
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.middleName`) : ""}
                            title="Další jména"
                            name={`${item}.middleName`}
                            component={Input}
                            disabled={disabled}
                          />
                        )}
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.lastName`) : ""}
                          title="Příjmení"
                          name={`${item}.lastName`}
                          component={Input}
                          disabled={disabled}
                          validate={[
                            V.required,
                            V.textSpaceDashOnly,
                            V.noSpaceStartEnd,
                          ]}
                        />
                      </div>
                    </div>
                  )}
                {sources.get(index).sourceType === Source.LEGAL_PERSON &&
                  (cityOrVillage || isLogged(auth)) && (
                    <div className="statementForm__arrayFull">
                      <div className="statementForm__arrayGrid">
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.name`) : ""}
                          title="Obchodní firma/název"
                          name={`${item}.legalPerson.name`}
                          component={Input}
                          disabled={disabled}
                          validate={[V.required]}
                          helpEnum={H[`${t}LIABILITY_LEGAL_PERSON_NAME`].r}
                        />
                        <div>
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.identificationNumber`) : ""}
                            title="IČO"
                            name={`${item}.legalPerson.identificationNumber`}
                            component={IcoInput}
                            disabled={disabled}
                            validate={
                              dos && (outgoing || ongoing)
                                ? [V.isNumeric]
                                : [V.required, V.isNumeric]
                            }
                            helpEnum={
                              H[
                                `${t}LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER`
                              ].r
                            }
                            onICOChange={(val) => onICOChange && onICOChange(index, val)}
                          />
                          {aresErrors && aresErrors[index] && (
                            <span className="cro-ares-error">{aresErrors[index]}</span>
                          )}
                        </div>

                        <p className="statementForm__arrayLabel">
                          Sídlo právnické osoby{" "}
                          <Help
                            helpEnum={H[`${t}LIABILITY_LEGAL_PERSON_ADDRESS`].r}
                            disabled={disabled}
                          />
                        </p>

                        <CroCountry
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.country`) : ""}
                          title="Stát"
                          name={`${item}.legalPerson.address`}
                          disabled={disabled}
                          form="statementForm"
                          validate={
                            !(dos && (outgoing || ongoing)) && [V.required]
                          }
                          defaultCountry={defaultCountry}
                        />
                        <CroMunicipality
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.municipality`) : ""}
                          title="Obec"
                          name={`${item}.legalPerson.address`}
                          disabled={disabled}
                          form="statementForm"
                          validate={
                            !(dos && (outgoing || ongoing)) && [V.required]
                          }
                        />

                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.street`) : ""}
                          title="Ulice"
                          name={`${item}.legalPerson.address.street`}
                          component={Input}
                          disabled={disabled}
                          validate={
                            !(dos && (outgoing || ongoing)) && [V.required]
                          }
                        />
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.orientationNumber`) : ""}
                          title="Č.p./Č.o."
                          name={`${item}.legalPerson.address.orientationNumber`}
                          component={Input}
                          disabled={disabled}
                          validate={
                            !(dos && (outgoing || ongoing)) && [V.required]
                          }
                          helpEnum={H.HOUSE_NUMBER.r}
                        />

                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.zip`) : ""}
                          title="PSČ"
                          name={`${item}.legalPerson.address.zip`}
                          component={Input}
                          disabled={disabled}
                          validate={
                            !(dos && (outgoing || ongoing)) && [V.required]
                          }
                        />
                      </div>
                    </div>
                  )}

                {noPublicLogged && (
                  <div className="statementForm__arrayFull">
                    <CroField
                      className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                      title="Poznámka"
                      name={`${item}.note`}
                      component={Input}
                      disabled={disabled}
                      multiline
                      helpEnum={H[`${t}LIABILITY_NOTE`].r}
                      maxlen={1000}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_LIABILITIES.r} />
        </div>
      )}
    </div>
  );
};
